import { Plus } from 'lucide-react';
import React from 'react';
import { array, string } from 'prop-types';
import css from './TypeSection.module.css';

import { FormattedMessage } from '../../../util/reactIntl';

const TypeSection = props => {
  const { sectionId, sectionData } = props;
  const titleText = (sectionData && sectionData[0]?.title?.content) || '';
  const descriptionText = (sectionData && sectionData[0]?.description?.content) || '';
  const blocks = (sectionData && sectionData[0]?.blocks) || [];

  return (
    <section id={sectionId} className={css.container}>
      <div className={css.wrapper}>
        <div className={css.text}>
          <div className={css.textLeft}>
            <div>
              <h1 className={css.heading}>{titleText}</h1>
            </div>
          </div>
          <div className={css.textRight}>
            <p className={css.description}>{descriptionText}</p>
          </div>
        </div>

        <div className={css.blocks}>
          <a href={blocks[0]?.callToAction?.href} className={css.left}>
            <div className={css.ctaBlock}>
              <h2>{blocks[0]?.title?.content}</h2>
              <img
                src={blocks[0]?.media?.image?.attributes?.variants?.original1200?.url}
                alt={blocks[0]?.media?.alt}
              />
              <div>
                <p className={css.ctaContent}>
                  <span className={css.ctaText}>{blocks[0]?.text?.content}</span>
                  <span className={css.cta}>
                    <FormattedMessage id="ProviderLandingPage.learnMore" />
                    <span className={css.iconWrapper}>
                      <Plus />
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </a>
          <a href={blocks[1]?.callToAction?.href} className={css.right}>
            <div className={css.ctaBlock}>
              <h2>{blocks[1]?.title?.content}</h2>
              <img
                src={blocks[1]?.media?.image?.attributes?.variants?.original1200?.url}
                alt={blocks[1]?.media?.alt}
              />
              <div>
                <p className={css.ctaContent}>
                  <span className={css.ctaText}>{blocks[1]?.text?.content}</span>
                  <span className={css.cta}>
                    <FormattedMessage id="ProviderLandingPage.learnMore" />
                    <span className={css.iconWrapper}>
                      <Plus />
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </a>
        </div>
      </div >
    </section >
  );
};

TypeSection.defaultProps = {
  sectionData: {},
};

TypeSection.propTypes = {
  sectionId: string.isRequired,
  sectionData: array,
};

export default TypeSection;
